<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
                <strong style="font-size: 25px">Tim Project</strong>
            </a-col>
            <a-col flex="0 1 300px">
                <a-button type="primary" icon="plus" block @click="addUser()">
                Tambah
                </a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.members"
                rowKey="hash"
                :pagination="false"
                :loading="loading"
                bordered>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <a-table-column key="gender" title="Gender" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ gender(record.gender) }}
                    </template>
                </a-table-column>

                <a-table-column key="role" title="Role" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <a-row type="flex" style="margin-bottom:10px">
                            <a-col :span="8"><strong>Klasikal Role</strong></a-col>
                            <a-col><strong>:</strong> {{ roleClassical(record.members[0].roles.classical) }}</a-col>
                        </a-row>
                        <a-row type="flex">
                            <a-col :span="8"><strong>OJT Role:</strong></a-col>
                            <a-col><strong>:</strong> {{ roleOjt(record.members[0].roles.evaluation) }}</a-col>
                        </a-row>
                    </template>
                </a-table-column>

                <a-table-column key="branch" title="Cabang" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.members[0].branch != null">
                            {{ record.members[0].branch.name }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="contact" title="Kontak" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <a-row type="flex" v-if="record.mobile_phone != null" style="margin-bottom:10px">
                            <a-col :span="2"><a-icon type="mobile"/></a-col>
                            <a-col>{{ record.mobile_phone }}</a-col>
                        </a-row>
                        <a-row type="flex" v-if="record.email != null">
                            <a-col :span="2"><a-icon type="mail" /></a-col>
                            <a-col>{{ record.email }}</a-col>
                        </a-row>
                    </template>
                </a-table-column>

                <a-table-column key="status" title="Status" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tag :color="record.is_active == true ? 'green' : 'red'">
                            {{ record.is_active == true ? "active" : "not active" }}
                        </a-tag>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tooltip title="Edit">
                            <a-button
                                size="small"
                                type="primary"
                                icon="edit"
                                @click="showModal(record)"
                            />
                        </a-tooltip>
                    </template>
                </a-table-column>

            </a-table>

            <a-modal
                :destroyOnClose="true"
                :footer="null"
                :visible="visible"
                :closable="false"
            >
                <admin-setting-user-project-form
                    :recordData="recordData"
                    @handleClose="closeModal"
                />
            </a-modal>
        </a-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: {},
            loading: false,
            processing: false,
            recordData: null,
            visible: false,
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
    },
    methods: {
        getItems() {
            this.loading = true;

            this.$http
                .get(this.routeUri("api.training-members") + "?is_attendant=0&")
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        },
        addUser() {
            let params = {
                team_project: 1
            }

            window.location.href = this.routeUri('admin.setting.user.form') + '?' + this.$qs.stringify(params)
        },
        showModal(recordData) {
            this.recordData = recordData;
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
        roleClassical(role) {
            switch(role) {
                case "project-owner": 
                    return "Project Owner"
                case "project-manager": 
                    return "Project Manager"
                case "project-owner-client": 
                    return "Project Owner Client"
                case "project-manager-client": 
                    return "Project Manager Client"
                case "project-sponsor": 
                    return "Project Sponsor"
                case "inspirator": 
                    return "Inspirator"
                default:
                    return "-"
            }
        },
        roleOjt(role) {
            switch(role) {
                case "advisor": 
                    return "Pembimbing"
                case "evaluator": 
                    return "Evaluator"
                case "mentor": 
                    return "Mentor"
                default:
                    return "-"
            }
        }
    }
}
</script>